<!-- 库房报损 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                       @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 主要信息 -->
                     <div v-if="scope.index == 0">
                        <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                           <el-row v-if="dataActionBox.actionType != 2">
                              <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                 <df-date @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0"
                                          v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                 <!-- 检索方案 -->
                                 <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                             :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                             effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField,formOneValue.focusField)"
                                              :disabled="(formOneValue.isChange == 0 || (sendDataInfo.desuConorderDetailAddList.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                       <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField,formOneValue.focusField)" slot="append"
                                                  icon="el-icon-search"
                                                  :disabled="(formOneValue.isChange == 0 || (sendDataInfo.desuConorderDetailAddList.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                       </el-button>
                                    </el-input>
                                 </el-tooltip>
                                 <!-- 发起类型 -->
                                 <el-select @visible-change="(e)=>{selectChange(e,formOneValue.focusField)}" v-else-if="formOneValue.fieldType == 'formatter'" v-model="sendDataInfo[formOneValue.entityField]"
                                            placeholder="请选择" :disabled="formOneValue.isChange == 0">
                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value"></el-option>
                                 </el-select>
                                 <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                           :disabled="formOneValue.isChange == 0"></el-input>
                              </el-form-item>
                           </el-row>
                           <el-row v-if="dataActionBox.actionType == 2">
                              <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                 <span v-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'date'">
                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                       {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                 </span>
                                 <span
                                       v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                 <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{sendDataInfo[formOneValue.entityField]== 1 ? "是" : "否" }}</span>
                                 <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                        </el-form>

                        <!-- 明细 -->
                        <el-form :inline="true" size="mini" @submit.native.prevent>
                           <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                              <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">新增</el-button>
                              <el-button type="primary" size="mini" @click="deleteDetails()">删除
                              </el-button>
                              <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                 <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                           </div>
                           <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.desuConorderDetailAddList" border style="width: 100%" :height="mxHeight">
                              <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                 <template slot-scope="scope">
                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                       <i class="el-icon-thumb"></i>
                                    </el-radio>
                                 </template>
                              </el-table-column>
                              <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                               v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                 <template slot-scope="scope">
                                    <!-- 商品 -->
                                    <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                              v-model="sendDataInfo.desuConorderDetailAddList[scope.$index].bgmName"
                                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" clearable>
                                       <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                  icon="el-icon-search"></el-button>
                                    </el-input>
                                    <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                              v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]"
                                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" clearable>
                                       <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                  icon="el-icon-search"></el-button>
                                    </el-input>
                                    <!-- 数量 -->
                                    <input class="newInput" @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)" @input="calculatePrice(5, scope.$index)" :ref="formOneValue.entityField"
                                           v-else-if="formOneValue.entityField == 'woadPnumber'&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number"
                                           v-model="sendDataInfo.desuConorderDetailAddList[scope.$index].woadPnumber" />
                                    <!-- 含税价格 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'psprice'
                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.desuConorderDetailAddList[scope.$index].woadPnumber <= 0"
                                              @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 最低售价 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'lowestPrice'
                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.desuConorderDetailAddList[scope.$index].woadPnumber <= 0"
                                              @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 单价 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'price'
                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.desuConorderDetailAddList[scope.$index].woadPnumber <= 0"
                                              @input="calculatePrice(1, scope.$index)" v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 金额 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'money'
                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.desuConorderDetailAddList[scope.$index].woadPnumber <= 0"
                                              @input="calculatePrice(3, scope.$index)" v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 含税金额 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'psmoney'
                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.desuConorderDetailAddList[scope.$index].woadPnumber <= 0"
                                              @input="calculatePrice(4, scope.$index)" v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 销项税率 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'outRate'
                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                              @input="calculatePrice(4, scope.$index)" v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <el-input :ref="formOneValue.entityField" v-else-if="dataActionBox.actionType != 2&&formOneValue.isChange==1"
                                              v-model="sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField]" type="number">
                                    </el-input>
                                    <!-- 有效期 -->
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="scope.row[formOneValue.entityField]">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
                                    </span>
                                    <span v-else>
                                       {{ sendDataInfo.desuConorderDetailAddList[scope.$index][formOneValue.entityField] }}
                                    </span>
                                 </template>
                              </el-table-column>

                           </el-table>
                        </el-form>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <!-- 页脚 -->
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                    @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchSchemeOther :isRepetition="isRepetition" :isRepetitionList="isRepetitionList" :isProp="'bgsId'" ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
         <el-table :data="dialogList" border style="width: 100%">
            <el-table-column prop="level" label="类型" width="50">
               <template slot-scope="{row}">
                  <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                     {{ row.level == 0 ? "拦截" : '预警' }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column prop="data" label="内容" min-width="180">
            </el-table-column>
            <el-table-column prop="validity" label="有效期" min-width="100">
               <template slot-scope="{row}">
                  {{ $common.getLocalTime(row.validity) }}
               </template>
            </el-table-column>
         </el-table>
         <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
         </span>
      </el-dialog>
      <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
      <printPlan ref="printPlan"></printPlan>
      <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
         <initDataUpload :coId="sendDataInfo.coId" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
         </initDataUpload>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "consignmentAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         detailsFlag: false,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         detaislDataInfo: {},
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         parentSearchData: {},
         seTitle: "", //检索
         DialogVisible: false,
         nextSearch: false,
         isRepetitionList: [],
         isRepetition: false,
         seWidth: "0",
         seId: 0,
         selectedDetailsIndex: 0, //选择索引
         focusIndex: 0, //检索焦点索引
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         importShow: false,
         importType: "",
         url: "",
         showDialog: false, // 预警/拦截规则弹窗
         dialogList: [], // 规则校验结果列表
         _cmSelectToken: 0, // 防并发令牌
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.desuConorderDetailAddList": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            this.sendDataInfo.totalGprofit = 0
            newValue.forEach((item, keys) => {
               this.$set(this.sendDataInfo.desuConorderDetailAddList[keys], 'psprice', this.$common.updataNum('psprice', item).psprice)
               this.$set(this.sendDataInfo.desuConorderDetailAddList[keys], 'woadPnumber', this.$common.updataNum('woadPnumber', item).woadPnumber)
               this.$set(this.sendDataInfo.desuConorderDetailAddList[keys], 'psmoney', this.$common.updataNum('psmoney', item).psmoney)
               this.$set(this.sendDataInfo.desuConorderDetailAddList[keys], 'outRate', this.$common.updataNum('outRate', item).outRate)
               this.$set(this.sendDataInfo.desuConorderDetailAddList[keys], 'lowestPrice', this.$common.updataNum('lowestPrice', item).lowestPrice)
               this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.totalMoney), parseFloat(item.psmoney)))
               this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.totalNumber), parseFloat(item.woadPnumber)))
               this.sendDataInfo.totalGprofit = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.totalGprofit), parseFloat(item.gross || 0)))
            });
            this.sendDataInfo.totalCount = newValue.length;
         },

         deep: true,
      },
      "sendDataInfo.stName": {
         handler: function (newstr, oldValue) {
            if (!newstr) {
               this.sendDataInfo.stId = "";
            }
         },
         deep: true,
      },
      "sendDataInfo.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               if (
                  this.dataActionBox.actionType == 0 ||
                  (this.dataActionBox.actionType == 1 &&
                     this.sendDataInfo.desuConorderDetailAddList.length == 0)
               ) {
                  this.sendDataInfo.cmId = "";
                  this.sendDataInfo.salesId = "";
                  this.sendDataInfo.salesName = "";
                  this.sendDataInfo.secondcmName = "";
                  this.sendDataInfo.secondcmId = "";
                  this.sendDataInfo.caiId = "";
                  this.sendDataInfo.caiAddress = "";
                  this.sendDataInfo.recId = "";
                  this.sendDataInfo.recName = "";
               }
            }
         },
         deep: true,
      },
      DialogVisible() {
         if (!this.DialogVisible) {
            this.nextSearch = false;
         }
      },
   },
   //方法集合
   methods: {
      // 触发组件的提交
      fileSuccess(val) {
      },
      // 关闭弹窗
      closeExcel(val) {
         this.importShow = false
         if (val.list.length > 0) {
            var list = []
            val.list.forEach(item => {
               list.push({})
               for (const key in item) {
                  this.$set(list[list.length - 1], key, item[key])
               }
            })
            this.sendDataInfo.desuConorderDetailAddList.push(...list)
         }
      },
      exportTemplate() {
         window.location.href = `${window.global_config.BASE_URL}/woApply/downSuDetailExcel`
      },
      importDetails() {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.importType = 'exportSuDetail'
               this.url = 'woApply/exportSuDetail'
               this.importShow = true
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });
      },
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'smIntype') {
            this.dictionariesDatas.forEach(item => {
               if (item.diValue == val) {
                  str = item.diName
               }
            })
         } else if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e, fField) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index, fField);
                  break;
               }
            }
         }
      },
      extract(sId) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = "extract";
         this.parentSearchData.foType = 0
         console.log(this.sendDataInfo);
         // this.seIndex
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      closeChild() {
         this.parentSearchData.bgmId = "";
         this.parentSearchData.bgmName = "";
      },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, flag, detailsFlag) {
         console.log(sId, index, type, sField, fField, flag, "测试");
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         this.detailsFlag = flag
         if (this.detailsFlag) {
            this.selectedDetailsIndex = this.seIndex
            this.parentSearchData[type] = this.sendDataInfo.desuConorderDetailAddList[this.selectedDetailsIndex][type];
            if (type == "bgmName") {
               this.isRepetition = false
               if (flag) {
                  this.isRepetition = true
                  this.isRepetitionList = this.sendDataInfo.desuConorderDetailAddList
               }
               for (let key in this.sendDataInfo) {
                  this.parentSearchData[key] = this.sendDataInfo[key];
               }
               if (!this.nextSearch)
                  this.parentSearchData.bgmName = this.sendDataInfo.desuConorderDetailAddList[this.seIndex].bgmName;
               if (this.parentSearchData.bgmName) {
                  let fh = 0;
                  if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                     fh = ",";
                  } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                     fh = "，";
                  }
                  if (fh !== 0) {
                     const str = this.parentSearchData.bgmName;
                     const list = str.split(fh);
                     this.parentSearchData.bgmName = list[0] || "";
                     this.parentSearchData.manufacturer = list[1] || "";
                  } else {
                     this.parentSearchData.manufacturer = "";
                  }
               } else {
                  this.parentSearchData.bgmName = "";
                  this.parentSearchData.manufacturer = "";
               }
               this.selectedDetailsIndex = this.seIndex;
               let refsElTable = this.$refs.mxTableRef;
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.desuConorderDetailAddList[this.selectedDetailsIndex]
               );
               return;
            }
         } else {
            if (type == "inStName") {
               this.parentSearchData.stName = this.sendDataInfo.inStName;
            } else {
               for (const key in this.sendDataInfo) {
                  if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
                     this.parentSearchData[key] = this.sendDataInfo[key];
                  } else {
                     this.parentSearchData[key] = ""
                  }
               }
            }
         }

      },
      lineMessageBox(data) {
         console.log(data);
         let txtArr = data.message.split("<br/>");
         let newArr = [];
         const h = this.$createElement;
         for (const i in txtArr) {
            newArr.push(h("p", null, txtArr[i]));
         }
         this.$alert(h("div", null, newArr), "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
         });
      },

      // 规则校验结果：有预警/拦截则弹窗，返回是否拦截(level==0)
      appendRuleResult(result) {
         if (!result || !result.length) return false;
         result.forEach((item) => this.dialogList.push(item));
         this.showDialog = true;
         return this.dialogList.some((item) => item.level == 0);
      },

      hasSetField(...fields) {
         return fields.every((f) => this.sField.indexOf(f) != -1);
      },

      isValidMeta(v) {
         return v != null && v !== "" && v !== "null";
      },

      // 清除赋值字段数据
      clearValue() {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = "";
         });
      },

      clearSalesFields(valObj) {
         if (valObj) {
            valObj.salesId = "";
            valObj.salesName = "";
         }
         this.sendDataInfo.salesId = "";
         this.sendDataInfo.salesName = "";
      },

      clearRecFields(valObj) {
         if (valObj) {
            valObj.recId = "";
            valObj.recName = "";
         }
         this.sendDataInfo.recId = "";
         this.sendDataInfo.recName = "";
      },

      // 通用表单规则校验：通过返回 true；失败/拦截返回 false
      async runRuleCheck(requestPromise, { clearOnFail = true, clearOnBlock = false } = {}) {
         this.showDialog = false;
         this.dialogList = [];
         try {
            const res = await requestPromise;
            if (!res || res.status != 200) {
               this.lineMessageBox(res);
               if (clearOnFail) this.clearValue();
               return false;
            }
            if (this.appendRuleResult(res.result)) {
               if (clearOnBlock) this.clearValue();
               return false;
            }
            return true;
         } catch (rej) {
            this.lineMessageBox(rej);
            if (clearOnFail) this.clearValue();
            return false;
         }
      },

      // 选择销售单位：校验单位 → 查默认业务员 → 校验业务员/收货员 → 赋值
      async handleCmNameSelect(val) {
         this.showDialog = false;
         this.dialogList = [];
         this._cmSelectToken = (this._cmSelectToken || 0) + 1;
         const token = this._cmSelectToken;
         const formId = this.formDataList[0].jciId;
         const isStale = () => token !== this._cmSelectToken;

         try {
            const checkRes = await this.$http.checkCustomerSale({
               formId,
               unitId: val.cmId,
            });
            if (isStale()) return;
            if (!checkRes || checkRes.status != 200) {
               this.lineMessageBox(checkRes);
               this.parentSearchData.cmId = "";
               this.clearValue();
               return;
            }
            if (this.appendRuleResult(checkRes.result)) return;

            this.parentSearchData.cmId = val.cmId;
            this.sendDataInfo.cmId = val.cmId;
            this.sendDataInfo.cmName = val.cmName;
            this.clearSalesFields();
            this.clearRecFields();

            let valObj = { ...val };
            try {
               const defaultRes = await this.$http.queryDefaultSales({ ids: [val.cmId] });
               if (isStale()) return;
               if (defaultRes && defaultRes.status == 200) {
                  valObj = { ...val, ...defaultRes.result };
               } else {
                  this.paramValue(val);
                  return;
               }
            } catch (rej) {
               if (isStale()) return;
               this.lineMessageBox(rej);
               this.paramValue(val);
               return;
            }

            const needSales =
               valObj.salesName &&
               valObj.salesId &&
               this.hasSetField("salesName", "salesId");
            if (!needSales) {
               this.paramValue(valObj);
               return;
            }

            try {
               const salesRes = await this.$http.checkSalesSale({
                  formId,
                  salesId: valObj.salesId,
               });
               if (isStale()) return;
               if (!salesRes || salesRes.status != 200) {
                  this.clearSalesFields(valObj);
                  this.clearRecFields(valObj);
                  this.lineMessageBox(salesRes);
                  this.paramValue(valObj);
                  return;
               }
               if (this.appendRuleResult(salesRes.result)) {
                  this.clearSalesFields(valObj);
                  this.clearRecFields(valObj);
                  this.paramValue(valObj);
                  return;
               }
               this.sendDataInfo.salesName = valObj.salesName;
               this.sendDataInfo.salesId = valObj.salesId;
            } catch (rej) {
               if (isStale()) return;
               this.clearSalesFields(valObj);
               this.clearRecFields(valObj);
               this.lineMessageBox(rej);
               this.paramValue(valObj);
               return;
            }

            const needRec =
               valObj.recName &&
               valObj.recId &&
               this.hasSetField("recName", "recId");
            if (!needRec) {
               this.paramValue(valObj);
               return;
            }

            try {
               const recRes = await this.$http.checkRecSalesSale({
                  formId,
                  salesId: valObj.recId,
               });
               if (isStale()) return;
               if (!recRes || recRes.status != 200) {
                  this.clearRecFields(valObj);
                  this.lineMessageBox(recRes);
                  this.paramValue(valObj);
                  return;
               }
               if (this.appendRuleResult(recRes.result)) {
                  this.clearRecFields(valObj);
               }
               this.paramValue(valObj);
            } catch (rej) {
               if (isStale()) return;
               this.clearRecFields(valObj);
               this.lineMessageBox(rej);
               this.paramValue(valObj);
            }
         } catch (rej) {
            if (isStale()) return;
            this.lineMessageBox(rej);
            this.parentSearchData.cmId = "";
            this.clearValue();
         }
      },

      //检索带回数据
      changeInputModel(val) {
         console.log("返hui", val, this.sendDataInfo.desuConorderDetailAddList);
         if (val == "" || val == null || val == undefined) return;
         this.DialogVisible = false; //关闭商品检索窗口
         this.$nextTick(() => {
            // 多选返回数组，单选返回对象，统一转成数组处理
            const list = Array.isArray(val) ? val : [val];
            // 处理级联检索（数组中任一元素含 nextSearchId 则触发级联）
            const cascadeItem = list.find(item => item && item.nextSearchId);
            if (cascadeItem) {
               this.nextSearch = true;
               this.parentSearchData.bgmId = cascadeItem.bgmId;
               this.parentSearchData.bgmName = cascadeItem.bgmName;
               this.openSearch(cascadeItem.nextSearchId, this.seIndex, "bgmName", "", "woadPnumber", true, true);
               return;
            }
            this.nextSearch = false;
            // 销售单位：走完整校验链
            if (this.seType == "cmName") {
               this.handleCmNameSelect(list[0]);
               return;
            }
            if (this.seType == "bgmName") {
               // 明细商品检索：数组第 1 个回填当前行，其余每个新增一行
               // 注：组件 SearchSchemeOther 不拦截灰显行的选中/双击，
               // 重复拦截全部由调用方按以下两个粒度把关：
               //   1) 跨明细重复：conmId + bgmId + bgsId（同一单据+同商品+同规格视为同明细）
               //   2) 行内全字段重复：batchno + bgmId + bgsId + expidate + lotno + prodate
               //      六者完全一致才算重复明细；任一不同就视为不同明细保留
               const listArr = this.sendDataInfo.desuConorderDetailAddList;
               // 已建明细的"跨明细键"和"行内全字段键"两个集合
               const detailKeySet = new Set();
               const rowKeySet = new Set();
               const norm = v => (v == null ? '' : String(v));
               listArr.forEach((row) => {
                  if (!row) return;
                  // 跨明细键
                  if (norm(row.bgmId) || norm(row.bgsId)) {
                     detailKeySet.add(`${norm(row.conmId)}__${norm(row.bgmId)}__${norm(row.bgsId)}`);
                  }
                  // 行内全字段键（六字段完全一致才算重复）
                  const rk = `${norm(row.batchno)}__${norm(row.bgmId)}__${norm(row.bgsId)}__${norm(row.expidate)}__${norm(row.lotno)}__${norm(row.prodate)}`;
                  // 任一字段为空都不算作"行内键"，避免空值行互相误判
                  if (norm(row.batchno) || norm(row.bgmId) || norm(row.bgsId) || norm(row.expidate) || norm(row.lotno) || norm(row.prodate)) {
                     rowKeySet.add(rk);
                  }
               });
               // 过滤弹窗选回的数据：命中跨明细键或行内键则丢弃
               const skipNames = [];
               const filteredList = [];
               list.forEach((item) => {
                  if (!item) return;
                  const dk = `${norm(item.conmId)}__${norm(item.bgmId)}__${norm(item.bgsId)}`;
                  const rk = `${norm(item.batchno)}__${norm(item.bgmId)}__${norm(item.bgsId)}__${norm(item.expidate)}__${norm(item.lotno)}__${norm(item.prodate)}`;
                  const hitDetail = (norm(item.bgmId) || norm(item.bgsId)) && detailKeySet.has(dk);
                  const hitRow = rowKeySet.has(rk) && (norm(item.batchno) || norm(item.bgmId) || norm(item.bgsId) || norm(item.expidate) || norm(item.lotno) || norm(item.prodate));
                  if (hitDetail || hitRow) {
                     skipNames.push(item.bgmName || item.goodsName || item.cmName || '该明细');
                  } else {
                     filteredList.push(item);
                  }
               });
               if (skipNames.length) {
                  const preview = skipNames.slice(0, 3).join('、');
                  const more = skipNames.length > 3 ? `等 ${skipNames.length} 条` : '';
                  this.$message.warning(`已存在相同明细，已自动跳过：${preview}${more}`);
               }
               if (filteredList.length === 0) return;
               let curIndex = this.selectedDetailsIndex;
               filteredList.forEach((item, idx) => {
                  if (!item) return;
                  if (idx === 0) {
                     // 第一个回填到当前行
                     const curRow = listArr[curIndex] || {};
                     Object.keys(item).forEach(key => {
                        if (item[key] !== undefined && item[key] !== null) {
                           this.$set(curRow, key, item[key])
                        }
                     })
                     if (!listArr[curIndex]) {
                        this.$set(listArr, curIndex, curRow);
                     }
                  } else {
                     // 后续每个新增一行
                     listArr.push({});
                     const newIndex = listArr.length - 1;
                     const newRow = listArr[newIndex];
                     // 先用 detaislDataInfo 模板填充默认值
                     for (const key in this.detaislDataInfo) {
                        this.$set(newRow, key, this.detaislDataInfo[key]);
                     }
                     // 再覆盖为检索值
                     Object.keys(item).forEach(key => {
                        if (item[key] !== undefined && item[key] !== null) {
                           this.$set(newRow, key, item[key])
                        }
                     })
                     curIndex = newIndex;
                  }
               })
               this.selectedDetailsIndex = curIndex;
               this.$nextTick(() => {
                  this.tableNextFocus(this.fField, this.selectedDetailsIndex);
                  let refsElTable = this.$refs.mxTableRef;
                  if (refsElTable) {
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.desuConorderDetailAddList[this.selectedDetailsIndex]
                     );
                  }
               });
            } else {
               // 非 bgmName 字段：只取第一个结果赋值，保持单选行为
               this.paramValue(list[0])
            }
         })
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         if (this.detailsFlag) {
            arr.forEach((item) => {
               this.sendDataInfo.desuConorderDetailAddList[this.seIndex][item] = val[item];
            });
            this.$nextTick(() => {
               this.tableNextFocus(this.fField, this.selectedDetailsIndex);
            });
         } else {
            arr.forEach((item) => {
               this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
               this.nextFocus(this.seIndex, this.fField);
            });
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         sendData.desuConorderDetailAddList = this.sendDataInfo.desuConorderDetailAddList.filter(item => item.bgmId != "" || item.bgmId != null || item.bgmName != "" || item.bgmName != null)
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.conorderadd(sendData);
         } else {
            var responseData = await this.$http.conorderupdate(sendData);
         }
         if (responseData.status == 200) {
            this.$refs.operSelect.openBox(responseData.result);
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      initActionBox(formName) {
         this.$confirm("确定取消吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.init();
               this.$emit("drawerCancel", 0);
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },
      conAdd() {
         this.dataActionBox.actionType = 0;
         this.filterMainField();
         this.checkIsBuyer();
      },
      drawerCancel() {
         this.$emit("drawerCancel", true);
      },
      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },
      //新增明细
      addDetails(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               //bgmId
               var flag = false;
               if (this.sendDataInfo.desuConorderDetailAddList.length > 0) {
                  this.sendDataInfo.desuConorderDetailAddList.forEach((item) => {
                     if (item.bgmId == "") {
                        flag = true;
                        this.$nextTick(() => {
                           this.selectedDetailsIndex = Number(
                              this.sendDataInfo.desuConorderDetailAddList.length - 1
                           );
                           this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                           let refsElTable = this.$refs.mxTableRef;
                           refsElTable.clearSelection();
                           refsElTable.toggleRowSelection(
                              this.sendDataInfo.desuConorderDetailAddList[
                              this.selectedDetailsIndex
                              ]
                           );
                        });
                     }
                  });
               }
               if (flag) {
                  return;
               }
               this.sendDataInfo.desuConorderDetailAddList.push({});
               var index = this.sendDataInfo.desuConorderDetailAddList.length - 1;
               for (const key in this.detaislDataInfo) {
                  this.$set(
                     this.sendDataInfo.desuConorderDetailAddList[index], key, this.detaislDataInfo[key]
                  );
               }
               this.$nextTick(() => {
                  this.selectedDetailsIndex = Number(
                     this.sendDataInfo.desuConorderDetailAddList.length - 1
                  );
                  this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.desuConorderDetailAddList[this.selectedDetailsIndex]
                  );
               });
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });

               return false;
            }
         });

      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.desuConorderDetailAddList[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.desuConorderDetailAddList[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.desuConorderDetailAddList.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.desuConorderDetailAddList.splice(this.selectedDetailsIndex, 1);
         this.selectedDetailsIndex = 0;
      },
      // 初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.comSaledate = this.$moment().valueOf()
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量
         this.sendDataInfo.desuConorderDetailAddList = [];
         this.checkIsBuyer();
      },
      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;

         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.filterMainField();

         console.log(this.dataActionBox.actionType, "2222");
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.checkIsBuyer();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.$set(this.sendDataInfo, "desuConorderDetailAddList", []);
            dataInfo.detailVoList.forEach(async (item, keys) => {
               this.sendDataInfo.desuConorderDetailAddList.push(item);
            });
            this.sendDataInfo.conmId=dataInfo.conmId
            delete this.sendDataInfo.detailVoList
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.$set(this.sendDataInfo, "desuConorderDetailAddList", []);
            dataInfo.detailVoList.forEach(async (item, keys) => {
               this.sendDataInfo.desuConorderDetailAddList.push(item);
            });
            this.sendDataInfo.conmId=dataInfo.conmId
            delete this.sendDataInfo.detailVoList
         }

         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
            this.initFocus();
         });
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 输入框切换焦点
      nextFocus(index, fField) {
         if (index >= this.inputel.length - 1) {
            if (this.sendDataInfo.desuConorderDetailAddList.length > 0) {
            }
            this.addDetails("sendDataInfo");
            return;
         }
         if (fField == "keydown") {
            this.addDetails("sendDataInfo");
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex, fField);
            return;
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus();
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            var index1 = 0
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) {
                  key.jurconfigform[index].isIndex = index1
                  index1++
               }
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "desuConorderDetailAddList" }];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
         this.sendDataInfo.comSaledate = this.$moment().valueOf()
         this.showTabs = this.tabForm[0].jciName;
      },
      // 计算价格
      calculatePrice(cate = 1, index, flag) {
         const info = this.sendDataInfo.desuConorderDetailAddList[index];

         // 安全检查，确保数据有效性（仅新增态校验）
         if (this.dataActionBox.actionType == 0) {
            if (info.woadPnumber < 0 || isNaN(info.woadPnumber)) {
               if (!flag) {
                  this.$message({
                     message: "请先填写合理的销售数量",
                     type: "error",
                  });
               }
               // 直接赋值，避免使用$set
               info.woadPnumber = 0;
               info.money = 0;
               info.psmoney = 0;
               info.gross = 0; //毛利
               info.costMoney = 0; //含税成本金额
               info.costAmount = 0; //成本金额
               if (!flag) {
                  this.calculatePrice(cate, index, true)
               }
               return false;
            } else if (info.woadPnumber > info.saleableNum) {
               this.sendDataInfo.desuConorderDetailAddList[index].woadPnumber = info.saleableNum;
               if (!flag) {
                  this.calculatePrice(cate, index, true)
               }
               this.$message({
                  message: "销售数量不能大于可销数量",
                  type: "error",
               });
               return
            }
         }

         // 缓存常用变量，避免重复访问
         const details = this.sendDataInfo.desuConorderDetailAddList[index];
         const quantity = parseFloat(info.woadPnumber) || 0;
         const taxRate = parseFloat(info.outRate) || 0;
         const price = parseFloat(info.price) || 0;
         const psprice = parseFloat(info.psprice) || 0;
         const psmoney = parseFloat(info.psmoney) || 0;
         const costMoney = parseFloat(info.woadWcost) || 0;
         const costAmount = parseFloat(info.costPrice) || 0;

         // 创建税率计算辅助函数
         const calculateTaxFactor = () => NP.plus(1, NP.divide(taxRate, 100));
         const calculateTaxAdjustedPrice = (basePrice) => this.$common.getDecimalInfo(2, NP.times(basePrice, calculateTaxFactor()));
         const calculateBaseFromTaxed = (taxedValue) => this.$common.getDecimalInfo(3, NP.divide(taxedValue, calculateTaxFactor()));

         switch (cate) {
            case 1: // 通过单价计算全部
               // 计算含税价格 单价+单价*税率/100
               details.psprice = calculateTaxAdjustedPrice(price);
               details.psmoney = this.$common.getDecimalInfo(3, NP.times(details.psprice, quantity)); // 计算含税金额 含税价格*数量
               details.money = calculateBaseFromTaxed(details.psmoney);
               details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money)); // 计算税额
               details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
               if (info.orPsprice != null && info.orPsprice != undefined) {
                  details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
               }
               break;
            case 2: // 通过含税价格计算全部
               // 计算含税金额 含税价格*数量
               details.psmoney = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(psprice, quantity));
               // 计算金额 含税金额/(税率/100+1)
               const midmoney = calculateBaseFromTaxed(details.psmoney);
               details.money = this.$common.getDecimalInfo(3, midmoney);
               // 计算单价 金额/数量
               details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, quantity));
               //计算税额
               details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
               details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
               if (info.orPsprice != null && info.orPsprice != undefined) {
                  details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
               }
               break;
            case 3: // 通过金额计算全部
               // 计算单价  金额 / 数量
               const calculatedPrice = quantity ? this.$common.getDecimalInfo(2, NP.divide(info.money, quantity)) : 0;
               details.price = calculatedPrice;
               // 计算含税价格 单价+单价*税率/100
               const taxAdjustedPrice = calculateTaxAdjustedPrice(calculatedPrice);
               details.psprice = taxAdjustedPrice
               // 计算含税金额 含税价格*数量
               details.psmoney = this.$common.getDecimalInfo(3, NP.times(taxAdjustedPrice, quantity));
               if (info.orPsprice != null && info.orPsprice != undefined) {
                  details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
               }
               //计算税额
               details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, info.money));
               details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
               break;
            case 4: // 通过含税金额计算全部
               // 计算总金额 含税金额/(税率/100+1)
               const midmoney2 = calculateBaseFromTaxed(psmoney);
               details.money = this.$common.getDecimalInfo(3, midmoney2);
               details.psprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(psmoney, quantity)); // 计算含税价格  含税金额 / 数量
               // 计算单价 金额/数量
               details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney2, quantity));
               //计算税额
               details.taxAmount = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.minus(psmoney, details.money));
               details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
               if (info.orPsprice != null && info.orPsprice != undefined) {
                  details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
               }
               break;
            case 6://销售报价
               details.saleQumoney = this.$common.getDecimalInfo(3, NP.times(info.saleQuprice || 0, quantity));
               break;
            case 7://报价金额
               details.saleQuprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.saleQumoney, quantity));
               break;
            case 8://通过含税原价
               details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
               details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
               details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.orMoney, quantity));
               details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
               break;
            case 9://通过不含税原价
               // 计算含税原价格 不含税原价+不含税原价*税率/100
               details.orPsprice = calculateTaxAdjustedPrice(info.orPrice);
               details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((details.orPsprice || 0), quantity));
               details.orMoney = this.$common.getDecimalInfo(3, NP.times((info.orPrice || 0), quantity));
               details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (details.orPsprice || 0)), 100));
               break;
            default:
               details.saleQumoney = this.$common.getDecimalInfo(3, NP.times(info.saleQuprice || 0, quantity));
               //通过数量计算
               // 计算含税金额 含税价格*数量
               const midmoney3 = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, quantity));
               details.psmoney = this.$common.getDecimalInfo(3, midmoney3);
               // 计算总金额 含税金额/(税率/100+1)
               details.money = calculateBaseFromTaxed(details.psmoney);
               // 计算单价 金额/数量
               details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity));
               // 计算 wholeNum整件数量  woadPnumber 销售数量    整件数量= 销售数量/装箱规格
               const wholeNum = parseFloat(info.packingSpec) > 0 && quantity > 0 ? Math.floor(NP.divide(quantity, Number(info.packingSpec))) : 0;
               details.wholeNum = wholeNum;
               //计算 scatNum 零散数量   wholeNum 整件数量   packingSpec 装箱规格    零散数量=销售数量-(整件数量*装箱规格)
               const scatNum = NP.minus(this.$common.getDecimalInfo(1, quantity), NP.times(wholeNum, Number(info.packingSpec)));
               details.scatNum = isNaN(scatNum) || String(scatNum) == 'NaN' ? 0 : scatNum;
               //计算税额
               details.taxAmount = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
               details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
               // 含税成本金额 = 含税成本 * 数量
               details.costMoney = this.$common.getDecimalInfo(3, NP.times(costMoney, quantity));
               // 成本金额 = 库存成本 * 数量
               details.costAmount = this.$common.getDecimalInfo(3, NP.times(costAmount, quantity));
               //通过含税原价计算
               if (info.orPsprice != null && info.orPsprice != undefined) {
                  details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                  details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                  details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.orMoney, quantity));
                  details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
               }
               // 计算件数 采数/包装单位  件数=销售数量/装箱规格
               if (
                  parseFloat(info.packingSpec) <= 0 ||
                  info.packingSpec == ""
               ) {
                  details.pieceNum = 0;
               } else {
                  details.pieceNum = this.$common.getDecimalInfo(1, NP.divide(quantity, info.packingSpec));
               }
               break;
         }

         // 计算折扣价格
         details.disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0));

         // 获取计算后的金额，确保是数字类型
         const moneyAfterTax = parseFloat(details.psmoney) || 0;
         const costMoneyAfterTax = parseFloat(details.costMoney) || 0;

         // 毛利 = 含税金额 - 成本含税金额
         details.gross = this.$common.getDecimalInfo(3, NP.minus(moneyAfterTax, costMoneyAfterTax));

         // 不含税毛利 = 金额 - 成本金额
         details.taxgross = this.$common.getDecimalInfo(3, NP.minus(parseFloat(details.money) || 0, parseFloat(details.costAmount) || 0));

         //毛利率
         details.grossProfit = moneyAfterTax != 0 ? this.$common.toFixed2(NP.divide(details.gross, moneyAfterTax), 2) : 0;

         // 更新所有总计数据
         this.updateTotalStats();
      },

      // 计算总的统计数据
      updateTotalStats() {
         let totalMoney = 0;
         let totalGross = 0;
         let totalNumber = 0;
         let totalCostMoney = 0;

         // 单次遍历计算所有总计值
         for (let i = 0; i < this.sendDataInfo.desuConorderDetailAddList.length; i++) {
            const detail = this.sendDataInfo.desuConorderDetailAddList[i];
            totalMoney += parseFloat(detail.psmoney) || 0;
            totalGross += parseFloat(detail.gross) || 0;
            totalNumber += parseFloat(detail.woadPnumber) || 0;
            totalCostMoney += parseFloat(detail.costMoney) || 0;
         }

         this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, totalMoney);
         this.sendDataInfo.totalGprofit = this.$common.getDecimalInfo(3, totalGross);
         this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, totalNumber);
         this.sendDataInfo.totalCostMoney = this.$common.getDecimalInfo(3, totalCostMoney);
         this.sendDataInfo.totalCount = this.sendDataInfo.desuConorderDetailAddList.length;
      },
      // 判断是不是采购员
      checkIsBuyer() {
         if (this.dataActionBox.actionType != 0) return;
         let info = JSON.parse(sessionStorage.getItem("userInfo"));
         let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
         if (ormInfo.isDefaultopm == 1) {
            if (info.opmSalesperson == 1) {
               this.sendDataInfo.depName = info.depName;
               this.sendDataInfo.depId = info.depId;
               this.sendDataInfo.opmName = info.opmName;
               this.sendDataInfo.opmId = info.opmId;
               this.tabForm[0].jurconfigform.forEach((item) => {
                  if (
                     item.entityField == "opmName" ||
                     item.entityField == "depName"
                  )
                     item.isChange = 0;
               });
            }
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>